
// - Basic settings - //

  // server
  export const API_URL = 'https://api.drmax.qtcloud.cz';

  // Google maps api key
  export const GOOGLE_API_KEY = 'AIzaSyDYNQYgSxetOOxyKCsBEotiYEIyAX7HK0M';

  // google recapcha v2
  export const CAPRCHA_CLIENT_KEY = '6LchWxYUAAAAAHS5JBSMFlSP3Fu-uHNr47WYzU0W';

  // title
  export const APP_TITLE = 'Rezervační systém - Dr. Max'; // 'Rezervační systém'

  // single office mode
  export const SINGLE_OFFICE_MODE = false;

  // graph statistics
  // - default: month or year
  export const STATS_DEFAULT_SETTING = 'year';
  // - if switching is bad idea
  export const STATS_SHOW_DATE_SWITCH = true;

// -------------------- //


// ~ Colors ~ //

  // color 1
  //  - main color in header and selected button
  export const COLOR_1 = '#4baa28';
  export const COLOR_1_BORDER_BOTTOM = '#e4012c';
  export const COLOR_1_BORDER_LEFT = '#4baa28';

  // color 2
  //  - color in header under logo
  export const COLOR_2 = '#4baa28';
  export const COLOR_2_BORDER_BOTTOM = '#e4012c';
  export const COLOR_2_BORDER_RIGHT = '#4baa28';

  // color 3
  //  - side panel color
  export const COLOR_3 = '#2e3647';
  export const COLOR_3_BORDER_RIGHT = 'rgba(73, 79, 94, 0.71)';

// -------------------- //
